/* eslint-disable no-undef */
import {
  getStoredPublicUser,
  getStoredPublicUserToken,
} from "./Auth";

export const chatLoader = (token) => {
  function initializeChatWidget(event) {
    console.log("Chat LOADED:", event);
  }

  const lang = localStorage.getItem("lang") || "en";
  const user = getStoredPublicUser();
  const authToken = token || getStoredPublicUserToken();

  if (!user?.id || !authToken) {
    window.isChatHide = true;
    return;
  }

  window.WizzChatWidget = {
    mode: "support",
    language: lang,
    userId: user.id,
    token: authToken,
  };

  window.support = true;
  window.supportModule = true;
  window.supportView = false;
  window.aiChat = false;
  window.isChatHide = false;
  window.hideIconApp = false;

  localStorage.setItem("access_token", authToken);
  localStorage.setItem("userId", user.id);

  if (!document.getElementById("root")) {
    const root = document.createElement("div");
    root.id = "root";
    document.body.appendChild(root);
  }

  WizzUtils.componentLoader({
    url: "https://sync.wizztech.us",
    func: initializeChatWidget,
    params: {
      apptype: "support",
      language: lang,
      token: authToken,
      userId: user.id,
    },
  });
};
